import styled from "styled-components";
import { BookingSummaryStyles } from "../../../types/styles";
import Icon, { IconType } from "../../Icon/Icon";

const StyledDiv = styled.div<{
  styles: BookingSummaryStyles;
  isErrored?: boolean;
}>`
  display: flex;
  column-gap: 4px;
  padding: 4px 0;
  font-size: 13px;
  font-weight: 500;
  background-color: transparent;
  color: ${({ styles, isErrored }) =>
    isErrored
      ? styles.DropdownGeneralValidationErrorColour
      : styles.BookingSummaryTextColour};
  border-radius: 4px;
  align-items: center;
`;

const IconContainer = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export type BookingSummaryItemProps = {
  children: string;
  icon: IconType;
  isErrored?: boolean;
  styles: BookingSummaryStyles;
  dataId?: string;
};

export const BookingSummaryItem: React.FC<BookingSummaryItemProps> = ({
  children,
  icon,
  isErrored,
  styles,
  dataId,
}) => {
  return (
    <StyledDiv styles={styles} isErrored={isErrored} data-id={dataId}>
      <IconContainer>
        <Icon
          icon={icon}
          color={isErrored ? undefined : styles.BookingSummaryTextColour}
        />
      </IconContainer>
      <label>{children}</label>
    </StyledDiv>
  );
};

export default BookingSummaryItem;
